document.addEventListener("DOMContentLoaded", function(){

const BLUE = "#01a9c6";

const logos = {
  pixaruv:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarUv.png?v=1779776354",
  pixarbluv:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarBluv.png?v=1779776354",
  pixaraqua:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAqua.png?v=1779776354",
  pixardrive:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarDrive.png?v=1779776354",
  pixarantifog:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAntifog.png?v=1779776354",
  beyaz:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/beyaz.png?v=1780120453",
  transitions:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/transitions.png?v=1779777682",
  transitionsX:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/transitionsX.png?v=1779777681",
  nPolar:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/nPolar_1.png?v=1780120453",
  driveWear:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/driveWear.png?v=1779777681",
  trivex:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/trivex.png?v=1779777681",
  trivexX:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/trivexX.png?v=1779777682",
  qvex:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/qvex.png?v=1779777681",
  qvexwizard:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/qvexwizard.png?v=1779777681",
  wizard:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/wizard.png?v=1779777681",
  pc:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pc.png?v=1779777682",
  pcTransitions:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pcTransitions.png?v=1779777681",
  pcNupolar:"https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pcNupolar.png?v=1779777681"
};

const coatingData = [
  {name:"PIXAR UV", logo:logos.pixaruv, features:[
    ["✳","Prevents reflections, presents pure vision"],
    ["💧","Superhydrophobic, water repellent"],
    ["✺","Anti-scratch"],
    ["◎","Anti-dust, easy clean"],
    ["☕","Anti-fog"],
    ["☂","Max UV Protection"]
  ]},
  {name:"PIXAR BLUV", logo:logos.pixarbluv, features:[
    ["✳","Prevents reflections, presents pure vision"],
    ["💧","Superhydrophobic, water repellent"],
    ["✺","Anti-scratch"],
    ["◎","Anti-dust, easy clean"],
    ["☕","Anti-fog"],
    ["☂","Max UV Protection"],
    ["⌁","Blue Light protection"]
  ]},
  {name:"PIXAR AQUA", logo:logos.pixaraqua, features:[
    ["✳","Prevents reflections, presents pure vision"],
    ["💧","Superhydrophobic, water repellent"],
    ["✺","Anti-scratch"],
    ["◎","Anti-dust, easy clean"],
    ["☕","Anti-fog"]
  ]},
  {name:"PIXAR DRIVE", logo:logos.pixardrive, features:[
    ["✳","Prevents reflections, presents pure vision"],
    ["💧","Superhydrophobic, water repellent"],
    ["✺","Anti-scratch"],
    ["◎","Anti-dust, easy clean"],
    ["☕","Anti-fog"]
  ]},
  {name:"PIXAR ANTIFOG", logo:logos.pixarantifog, features:[
    ["✳","Prevents reflections, presents pure vision"],
    ["💧","Superhydrophobic, water repellent"],
    ["✺","Anti-scratch"],
    ["◎","Anti-dust, easy clean"],
    ["⌁","Blue Light protection"]
  ]}
];

const data = {
 "1.50":[
  {name:"Beyaz",logo:logos.beyaz,title:"Individual free form single vision",index:"1.50",abbe:58,density:"1.32",uv:350,thin:"",rx:[[80,-4,7],[75,-7,8],[70,-10,8],[65,-11,14],[60,-12,14],[55,-13,null],[50,-14,null]]},
  {name:"Transitions",logo:logos.transitions,title:"Photochromic, Individual free form single vision",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[70,-10,8],[65,-11,8],[60,-12,8],[55,-13,null],[50,-14,null]],colors:["Brown","Smoked"]},
  {name:"Transitions XTRActive",logo:logos.transitionsX,title:"Photochromic, Individual free form single vision",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[75,-7,8],[70,-10,8],[65,-11,8],[60,-12,8],[55,-13,null],[50,-14,null]],colors:["Smoked"]},
  {name:"NPolar",logo:logos.nPolar,title:"Polarized, Individual free form single vision",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[80,-4,7],[75,-7,8],[70,-7,8],[65,-8,8],[60,-9,8],[55,-10,null],[50,-11,null]],colors:["Brown","Smoked","G15"]},
  {name:"DriveWear",logo:logos.driveWear,title:"Photochromic, Individual free form single vision",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[70,-8,8],[65,-9,8],[60,-10,8],[55,-11,null],[50,-12,null]]}
 ],
 "1.53":[
  {name:"Trivex Transitions",logo:logos.trivexX,title:"Photochromic Individual free form single vision",index:"1.53",abbe:45,density:"1.11",uv:400,thin:"%35 thinner",rx:[[75,-7,8],[70,-8,8],[65,-9,8],[60,-10,8],[55,-11,null],[50,-12,null]],colors:["Smoked"]}
 ],
 "1.57":[
  {name:"Q-vex",logo:logos.qvex,title:"Individual free form single vision",index:"1.57",abbe:46,density:"1.15",uv:400,thin:"%40 thinner",rx:[[80,-4,7],[75,-5,8],[70,-13,8],[65,-14,10],[60,-12,10],[55,-16,null],[50,-17,null]]},
  {name:"Q-vex Wizard",logo:logos.qvexwizard,title:"Photochromic Individual free form single vision",index:"1.57",abbe:46,density:"1.15",uv:400,rx:[[75,-4,7],[70,-12,7],[65,-13,7],[60,-14,7],[55,-15,null],[50,-7,null]]}
 ],
 "1.58":[
  {name:"Beyaz",logo:logos.beyaz,title:"Individual free form single vision",index:"1.58",abbe:38,density:"1.28",uv:380,thin:"%40 thinner",rx:[[80,-4,7],[75,-5,8],[70,-13,8],[65,-14,16],[60,-15,16],[55,-16,null],[50,-17,null]]},
  {name:"Wizard",logo:logos.wizard,title:"Photochromic, Individual free form single vision",index:"1.58",abbe:58,density:"1.32",uv:380,thin:"%40 thinner",rx:[[75,-11,7],[70,-12,7],[65,-13,7],[60,-14,7],[55,-15,null],[50,-7,null]]}
 ],
 "1.59 PC":[
  {name:"PC",logo:logos.pc,title:"Polycarbonate, Individual freeform single vision",index:"1.59",abbe:30,density:"1.22",uv:380,thin:"%40 thinner",rx:[[70,-12,8],[65,-13,8],[60,-14,8],[55,-15,null],[50,-16,null]]},
  {name:"PC Transitions",logo:logos.pcTransitions,title:"Photochromic Polycarbonate, Individual freeform single vision",index:"1.59",abbe:30,density:"1.22",uv:400,rx:[[75,-8,8],[70,-10,8],[65,-11,8],[60,-12,8],[55,-13,null],[50,-14,null]],colors:["Smoked"]},
  {name:"PC NuPolar",logo:logos.pcNupolar,title:"Polarized Polycarbonate, Individual freeform single vision",index:"1.59",abbe:30,density:"1.22",uv:400,rx:[[75,-9,7],[70,-10,6],[65,-11,6],[60,-12,6],[55,-13,null],[50,-14,null]],colors:["Brown","Smoked"]}
 ],
 "1.61":[
  {name:"Beyaz",logo:logos.beyaz,title:"Individual free form single vision",index:"1.61",abbe:42,density:"1.30",uv:385,thin:"%45 thinner",rx:[[75,-8,8],[70,-13,13],[65,-14,13],[60,-15,13],[55,-16,null],[50,-17,null]]},
  {name:"Wizard",logo:logos.wizard,title:"Photochromic, Individual free form single vision",index:"1.61",abbe:42,density:"1.30",uv:400,rx:[[75,-10,7],[70,-11,7],[65,-12,7],[60,-13,7],[55,-14,null],[50,-7,null]],colors:["Brown","Smoked"]},
  {name:"Transitions",logo:logos.transitions,title:"Photochromic, Individual free form single vision",index:"1.61",abbe:42,density:"1.30",uv:400,rx:[[70,-13,11],[65,-14,11],[60,-15,11],[55,-16,null],[50,-17,null]],colors:["Brown","Smoked"]}
 ],
 "1.67":[
  {name:"Beyaz",logo:logos.beyaz,title:"Individual free form single vision",index:"1.67",abbe:34,density:"1.37",uv:390,thin:"%60 thinner",rx:[[75,-10,8],[70,-13,14],[65,-14,14],[60,-15,14],[55,-16,null],[50,-17,null]]},
  {name:"Wizard",logo:logos.wizard,title:"Photochromic, Individual free form single vision",index:"1.67",abbe:34,density:"1.37",uv:400,rx:[[70,-10,12],[65,-11,12],[60,-12,12],[55,-13,null],[50,-14,null]],colors:["Brown","Smoked"]},
  {name:"Transitions",logo:logos.transitions,title:"Photochromic, Individual free form single vision",index:"1.67",abbe:34,density:"1.37",uv:400,rx:[[75,-10,7],[70,-11,7],[65,-12,7],[60,-13,7],[55,-14,null],[50,-7,null]],colors:["Brown","Smoked"]},
  {name:"NPolar",logo:logos.nPolar,title:"Polarized, Individual freeform single vision",index:"1.67",abbe:34,density:"1.37",uv:400,rx:[[75,-8,8],[70,-10,8],[65,-11,8],[60,-12,8],[55,-13,null],[50,-14,null]],colors:["Brown","Smoked"]}
 ],
 "1.74":[
  {name:"Beyaz",logo:logos.beyaz,title:"Individual free form single vision",index:"1.74",abbe:33,density:"1.47",uv:395,thin:"%65 thinner",rx:[[70,-16,14],[65,-17,14],[60,-19,14],[55,-21,null],[50,-23,null]]},
  {name:"Transitions",logo:logos.transitions,title:"Photochromic, Individual free form single vision",index:"1.74",abbe:33,density:"1.47",uv:400,rx:[[70,-15,13],[65,-16,13],[60,-17,13],[55,-19,null],[50,-21,null]],colors:["Smoked"]}
 ]
};

let activeIndex = "1.50";
let activeMaterial = 0;

function uvDeg(uv){
  if(uv <= 350) return "115deg";
  if(uv <= 380) return "135deg";
  if(uv <= 385) return "142deg";
  if(uv <= 390) return "150deg";
  if(uv <= 395) return "160deg";
  return "174deg";
}

function colorDots(colors){
  if(!colors) return "";
  const map = {Brown:"#7a5737", Smoked:"#173431", G15:"#405f44"};
  return `<div class="gt-colors">Color Options : ${
    colors.map(c=>`${c} <span class="gt-color-dot" style="background:${map[c]||'#333'}"></span>`).join("")
  }</div>`;
}

function renderCoatings(){
  const tabs = document.getElementById("coatingTabs");
  const box = document.getElementById("coatingBox");
  if(!tabs || !box) return;

  let current = 0;

  function draw(){
    tabs.innerHTML = coatingData.map((c,i)=>`
      <button class="gt-coating-tab ${i===current?'active':''}" data-i="${i}">
        <img src="${c.logo}" alt="${c.name}">
      </button>
    `).join("");

    box.innerHTML = coatingData[current].features.map(f=>`
      <div class="gt-feature">
        <div class="gt-icon">${f[0]}</div>
        <div>${f[1]}</div>
      </div>
    `).join("");

    tabs.querySelectorAll("button").forEach(btn=>{
      btn.onclick = () => { current = Number(btn.dataset.i); draw(); };
    });
  }

  draw();
}

function renderIndexTabs(){
  const el = document.getElementById("indexTabs");
  el.innerHTML = Object.keys(data).map(k=>`
    <button class="gt-index-tab ${k===activeIndex?'active':''}" data-index="${k}">${k}</button>
  `).join("");

  el.querySelectorAll("button").forEach(btn=>{
    btn.onclick = () => {
      activeIndex = btn.dataset.index;
      activeMaterial = 0;
      renderAll();
    };
  });
}

function renderMaterialTabs(){
  const el = document.getElementById("materialTabs");
  el.innerHTML = data[activeIndex].map((m,i)=>`
    <button class="gt-material-tab ${i===activeMaterial?'active':''}" data-i="${i}">
      <img src="${m.logo}" alt="${m.name}">
    </button>
  `).join("");

  el.querySelectorAll("button").forEach(btn=>{
    btn.onclick = () => {
      activeMaterial = Number(btn.dataset.i);
      renderAll();
    };
  });
}

function renderRx(rx){
  const min = -24, max = 16, span = max - min;

  return `
    <div class="gt-rx">
      <div style="font-weight:700;margin-bottom:6px;">RX Range</div>
      ${rx.map(r=>{
        const dia = r[0], left = r[1], right = r[2];
        const lPct = ((left - min) / span) * 100;
        const rPct = right === null ? ((0 - min) / span) * 100 : ((right - min) / span) * 100;
        const width = Math.max(rPct - lPct, 1);
        return `
          <div class="gt-rx-row">
            <div class="gt-rx-dia">${dia}</div>
            <div class="gt-rx-track">
              <div class="gt-rx-fill" style="left:${lPct}%;width:${width}%;">
                <span style="left:-26px;">${left}</span>
                ${right !== null ? `<span style="right:-30px;">+${right}</span>` : ``}
              </div>
            </div>
          </div>
        `;
      }).join("")}
    </div>
  `;
}

function renderSpec(){
  const d = data[activeIndex][activeMaterial];
  const panel = document.getElementById("specPanel");

  panel.innerHTML = `
    <div class="gt-spec-title">${d.title}</div>

    <div class="gt-spec-grid">
      <div>
        <div class="gt-spec-label">Index</div>
        <div class="gt-index-visual">
          <div class="gt-index-bracket"></div>
          <div class="gt-big-num">${d.index}</div>
        </div>
      </div>

      <div>
        <div class="gt-spec-label">Abbe νe</div>
        <div class="gt-ring">${d.abbe}</div>
      </div>

      <div>
        <div class="gt-spec-label">Density ρ</div>
        <div class="gt-density-wrap">
          <div class="gt-bar"><span style="height:${Math.min(Number(d.density)/1.5*100,100)}%"></span></div>
          <div class="gt-density-value">
            <div class="main">${d.density}</div>
            <small>g/m³</small>
          </div>
        </div>
      </div>

      <div>
        <div class="gt-spec-label">UV Cut</div>
        <div class="gt-uv-wrap">
          <div class="gt-uv-arc" style="--uv-deg:${uvDeg(d.uv)}"></div>
          <div class="gt-uv-value">${d.uv}<br>nm</div>
        </div>
      </div>
    </div>

    ${renderRx(d.rx)}

    <p class="gt-note">
      This advanced FreeForm single vision design is calculated for individual measurements and supports improved visual comfort across the lens surface. It is especially useful for sport and curved-frame applications where lens position can affect clarity.
    </p>

    ${d.thin ? `<div class="gt-thin">${d.thin}<br><small>(compared to 1.5 index organic lenses)</small></div>` : ``}

    ${d.name.toLowerCase().includes("trivex") || d.name.toLowerCase().includes("q-vex") ? `
      <p class="gt-note">
        Durable, lightweight material with strong optical clarity and reliable impact resistance, making it suitable for active lifestyles and sport frames.
      </p>
    ` : ``}

    ${d.name.toLowerCase().includes("pc") ? `
      <p class="gt-note">
        Polycarbonate material provides impact resistance and everyday safety, especially for rimless, sport, and active-use eyewear.
      </p>
    ` : ``}

    ${d.name.toLowerCase().includes("polar") || d.name.toLowerCase().includes("drive") ? `
      <p class="gt-note">
        This option helps reduce reflected glare and supports clearer contrast in bright outdoor environments.
      </p>
    ` : ``}

    ${d.name.toLowerCase().includes("transition") || d.name.toLowerCase().includes("wizard") ? `
      <p class="gt-note">
        Photochromic performance helps protect the eyes from changing light conditions and harmful UV exposure.
      </p>
    ` : ``}

    ${colorDots(d.colors)}
  `;
}

function renderAll(){
  renderIndexTabs();
  renderMaterialTabs();
  renderSpec();
}

function initBeforeAfter(){
  const box = document.getElementById("baBox");
  const after = document.getElementById("baAfter");
  const slider = document.getElementById("baSlider");
  if(!box || !after || !slider) return;

  function move(x){
    const rect = box.getBoundingClientRect();
    let pct = ((x - rect.left) / rect.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    after.style.width = pct + "%";
    slider.style.left = pct + "%";
  }

  box.addEventListener("mousemove", e => move(e.clientX));
  box.addEventListener("touchmove", e => {
    if(e.touches[0]) move(e.touches[0].clientX);
  }, {passive:true});
}

renderCoatings();
renderAll();
initBeforeAfter();

});
